<template>
    <div :class="['Object', {'Object--liked': liked}]">
        <div class="show-mobile">
            <div class="Object__id">ID {{id}}</div>
            <div class="Object__name"><router-link :to="{name: 'object', params: {id}}" class="ObjectMoreInfoLink">{{name}}</router-link></div>
            <div class="Object__location">{{location}}</div>
        </div>
        <div class="Object__images">
            <ImageSlider2  v-if="images.length" :images="images" :id="id"/>
            <NoImages v-else></NoImages>
        </div>
        <div class="Object__info">
            <div class="hide-mobile">
                <div class="Object__id">ID {{id}}</div>
                <div class="Object__name">
                    <router-link :to="{name: 'object', params: {id}}" class="ObjectMoreInfoLink">{{name}}</router-link>
                </div>
                <div class="Object__location">{{location}}</div>
            </div>
            <div class="Object__price">
                <ObjectPrice :current="price.current" :prev="price.prev" :tp="tp"/>
            </div>
            <div class="Object__params">
                <ObjectParams :params="params"/>
            </div>
            <div class="Object__more-info-link">
                <ObjectMoreInfoLink :id="id">
                    Узнать подробнее
                </ObjectMoreInfoLink>
            </div>
            <ObjectLikeButtons :id="id" :status="likeStatus"/>
        </div>
    </div>
</template>

<script>

import ObjectPrice from "@/components/Object/ObjectPrice";
import ObjectParams from "@/components/Object/ObjectParams";
import ImageSlider2 from "@/components/Object/ImageSlider2";
import ObjectLikeButtons from "@/components/Object/ObjectLikeButtons";
import ObjectMoreInfoLink from "@/components/Object/ObjectMoreInfoLink";
import NoImages from "@/components/elements/NoImages";

export default {
    name: "Object",
    inheritAttrs: false,
    components: {
        ObjectPrice,
        ObjectParams,
        ImageSlider2,
        ObjectLikeButtons,
        ObjectMoreInfoLink,
        NoImages
    },
    props: {
        id: [Number, String],
        name: String,
        location: String,
        price: {
            current: [Number, String],
            prev: [Number, String]
        },
        params: Object,
        likeStatus: Number,
        images: Array,
        tp: Number
    },
    computed: {
        liked() {
            console.log(this.likeStatus)
            return this.likeStatus === 1;
        },
    },
}
</script>

<style lang="scss">
.Object {
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  border: solid 2px transparent;

  @include tablet {
    border-radius: 8px;
  }

  @include mobile {
    border: none;
    border-radius: 0;
    background-color: $white;
    flex-direction: column;
    padding: 16px;
  }

  &--liked {
    border-color: $secondary;
  }

  &__images {
    width: 640px;
    flex-shrink: 0;

    @include tablet {
      width: 350px;
    }

    @include mobile {
      width: 100%;
      height: 190px;
      border-radius: 8px;
      overflow: hidden;
      margin-bottom: 14px;
    }
  }

  &__info {
    display: flex;
    flex-direction: column;
    background-color: $white;
    width: 100%;
    padding: 32px 32px 24px;

    @include tablet {
      padding: 16px;
    }

    @include mobile {
      padding: 0;
    }
  }

  &__id {
    margin-bottom: 24px;
    font-size: 12px;

    @include tablet {
      margin-bottom: 8px;
    }
  }

  &__name {
    margin-bottom: 8px;
    font-size: 26px;
    font-weight: 500;

    @include tablet {
      font-size: 20px;
      margin-bottom: 8px;
    }
  }

  &__location {
    margin-bottom: 14px;
    font-weight: 300;
  }

  &__price {
    margin-bottom: 24px;

    @include tablet {
      margin-bottom: 16px;
    }
  }

  &__params {
    margin-bottom: 24px;

    @include tablet {
      margin-bottom: 12px;
    }

    @include mobile {
      margin-bottom: 16px;
    }
  }

  &__more-info-link {
    margin-bottom: 50px;

    @include tablet {
      margin-bottom: 24px;
    }

    @include mobile {
      order: 2;
      margin-bottom: 0;
      margin-top: 16px;

      .ObjectMoreInfoLink {
        height: 31px;
        justify-content: center;
      }
    }
  }
}
</style>